
import { Vue, Options } from "vue-class-component";
import Settings from "@/components/Settings.vue";
@Options({
  components: {
    Settings,
  },
})
export default class SettingsView extends Vue {}
